module.exports = __webpack_public_path__ + "img/b2.8becd360.png";